import axios from '../helpers/axios'
import { logError } from '../services';
import qs from 'querystring';
import {
  IDropdownResponse,
  IResponse,
  IContentLibraryDocument,
  IUpdateContentLibrary,
  ICreateContentLibrary,
  IContentLibraryMissingDoc,
  IAvailableTemplateTypes
} from '../models';

export const getContentLibraryDocuments = async (filters?: {
  search?: string;
  contentPlaceHolderBlock?: string;
  vendorTypeId?: number | string;
  subcontractorTypeId?: number | string;
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number;
}): Promise<IResponse<IContentLibraryDocument[]>> => {
  try {
    const { data } = await axios.get(`/api/content-library-documents`, {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error) {
    logError(error, 'getContentLibraryDocuments failed');
    return Promise.reject(error);
  }
};

export const getPlaceHolderBlocks = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/content-library-documents/content-place-holder-blocks`);
    return data;
  } catch (error) {
    logError(error, 'getPlaceHolderBlocks failed');
    return Promise.reject(error);
  }
};

export const createContentLibrary = async (payload: ICreateContentLibrary): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/content-library-documents`, payload);
    return data;
  } catch (error) {
    logError(error, 'createContentLibrary failed');
    return Promise.reject(error);
  }
};

export const updateContentLibrary = async (payload: IUpdateContentLibrary): Promise<any> => {
  try {
    const { data } = await axios.put(`/api/content-library-documents`, payload);
    return data;
  } catch (error) {
    logError(error, 'updateContentLibrary failed');
    return Promise.reject(error);
  }
};

export const deleteContentLibraryDoc = async (id: string): Promise<any> => {
  try {
    const { data } = await axios.delete(`/api/content-library-documents/${id}`);
    return data;
  } catch (error) {
    logError(error, 'createContentLibrary failed');
    return Promise.reject(error);
  }
};

export const getContentLibraryMissingDocuments = async (filters?: {
  query?: string;
}): Promise<IContentLibraryMissingDoc[]> => {
  try {
    const { data } = await axios.get(`/api/panda-doc/content-libraries/missing`, {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error) {
    logError(error, 'getContentLibraryMissingDocuments failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getContentLibraryAvailableTypes = async (): Promise<IAvailableTemplateTypes[]> => {
  try {
    const { data } = await axios.get(
      `/api/content-library-documents/available-content-library-types`
    );
    return data;
  } catch (error) {
    logError(error, 'getContentLibraryAvailableTypes failed');
    return Promise.reject(error);
  }
};
